import "../../styles/ui/native-animations.scss";

import React, {useEffect, useRef, useState} from "react";
import cn from "classnames";

// Render the content on the server; only the entrance effect needs the browser.
const Reveal = ({as: Element = "div", onScroll = false, className, style, ...props}) => {
    const elementRef = useRef(null);
    const [phase, setPhase] = useState(onScroll ? "static" : "visible");

    useEffect(() => {
        if (!onScroll || typeof IntersectionObserver === "undefined") return;

        const element = elementRef.current;
        const bounds = element.getBoundingClientRect();
        if (bounds.top < window.innerHeight && bounds.bottom > 0) {
            // It is already visible in SSR. Do not hide it again during hydration.
            return;
        }

        setPhase("pending");
        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
                setPhase("visible");
                observer.disconnect();
            }
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, [onScroll]);

    return (
        <Element
            {...props}
            ref={elementRef}
            className={cn(className, "ui-reveal")}
            data-reveal={phase}
            style={style}
        />
    );
};

export default Reveal;
